/**
 * Strict `formatter` for vue2-datepicker (CRM pickers).
 *
 * The picker's default parser lets out-of-range parts roll over, so "99/99/9999" typed
 * as MM/DD/YYYY becomes 07/06/10007. This parser only accepts text that matches the
 * format exactly with a real calendar date in a sensible year range; anything else
 * comes back as an invalid Date, which the picker rejects (it emits `input-error`).
 */
export const MIN_YEAR = 1900;
export const MAX_YEAR = 2100;
const TOKEN_PATTERN = /YYYY|MM|M|DD|D/g;
function invalidDate() {
    return new Date(NaN);
}
function isRealDate(year, month, day) {
    if (year < MIN_YEAR || year > MAX_YEAR || month < 1 || month > 12 || day < 1) {
        return false;
    }
    return day <= new Date(year, month, 0).getDate();
}
export function parseStrictDate(text, format) {
    const value = (text || "").trim();
    if (!value || !format) {
        return invalidDate();
    }
    // Only numeric Y/M/D formats are supported (user formats are DD/MM/YYYY or MM/DD/YYYY, values YYYY-MM-DD)
    if (/[A-Za-z]/.test(format.replace(TOKEN_PATTERN, ""))) {
        return invalidDate();
    }
    const order = [];
    const pattern = format.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(TOKEN_PATTERN, (token) => {
        order.push(token);
        return token === "YYYY" ? "(\\d{4})" : "(\\d{1,2})";
    });
    const match = new RegExp(`^${pattern}$`).exec(value);
    if (!match) {
        return invalidDate();
    }
    let year = 0;
    let month = 0;
    let day = 0;
    order.forEach((token, index) => {
        const part = Number(match[index + 1]);
        if (token === "YYYY") {
            year = part;
        }
        else if (token.charAt(0) === "M") {
            month = part;
        }
        else {
            day = part;
        }
    });
    return isRealDate(year, month, day) ? new Date(year, month - 1, day) : invalidDate();
}
// Only `parse` is overridden; the picker keeps its own display formatting
export const strictDateFormatter = {
    parse: parseStrictDate,
};
